module.exports = __webpack_public_path__ + "static/media/driver-icon.4fcebcc0.svg";